import React from "react";
import {Button, ButtonType} from "@reapptor-apps/reapptor-react-components";
import CruiseWizardPage from "@/pages/Cruise/CruiseWizardPage";
import CruiseArea from "@/models/server/CruiseArea";
import CruiseCountry from "@/models/server/CruiseCountry";
import {ReactUtility} from "@reapptor-apps/reapptor-react-common";
import {CruiseExtra} from "@/models/Enums";
import Localizer from "@/localization/Localizer";

import styles from "./Extra.module.scss";

import extraBuffet from "./images/buffet.png";
import extraSnacks from "./images/snacks.png";
import extraAlcohol from "./images/alcohol.png";
import extraFishingEquipment from "./images/fishing-equipment.png";
import extraNothing from "./images/nothing.png";

export interface IExtraProps {
}

interface IExtraState {
}

export default class Extra extends CruiseWizardPage<IExtraProps, IExtraState> {

    state: IExtraState = {};

    public async selectAsync(extra: CruiseExtra | null): Promise<void> {
        if (extra != null) {
            if (this.wizard.extras.includes(extra)) {
                this.wizard.extras.remove(extra);
            } else {
                this.wizard.extras.push(extra);
            }
        } else {
            this.wizard.extras = [];
        }
        
        this.saveContext();

        await this.reRenderAsync();
        
        if (this.isFishing) {
            await this.nextAsync();
        }
    }

    public isSelected(extra: CruiseExtra | null): boolean {
        return (extra != null)
            ? (this.wizard.extras.includes(extra))
            : (this.wizard.extras.length == 0);
    }

    public get title(): string | null {
        return (this.isFishing)
            ? Localizer.cruiseWizardExtraFishingTitle
            : Localizer.cruiseWizardExtraTitle;
    }

    public get country(): CruiseCountry | null {
        return this.wizard.country;
    }

    public get area(): CruiseArea | null {
        return this.wizard.area;
    }

    public get buffetPrice(): string {
        return ((this.country) && (this.area) && (this.area.estimatedPrice) && (this.area.buffetPrice > 0))
            ? Localizer.cruiseWizardBuffetPrice.format(this.area.buffetPrice, this.country.moneySymbol)
            : "";
    }

    public get snacksPrice(): string {
        return ((this.country) && (this.area) && (this.area.estimatedPrice) && (this.area.snacksPrice > 0))
            ? Localizer.cruiseWizardSnacksPrice.format(this.area.snacksPrice, this.country.moneySymbol)
            : "";
    }

    public get alcoholPrice(): string {
        return ((this.country) && (this.area) && (this.area.estimatedPrice) && (this.area.alcoholPrice > 0))
            ? Localizer.cruiseWizardAlcoholPrice.format(this.area.alcoholPrice, this.country.moneySymbol)
            : "";
    }

    public get fishingEquipmentPrice(): string {
        return ((this.country) && (this.area) && (this.area.estimatedPrice) && (this.area.fishingEquipmentPrice > 0))
            ? Localizer.cruiseWizardFishingEquipmentPrice.format(this.area.fishingEquipmentPrice, this.country.moneySymbol)
            : "";
    }

    public get noThankYouPrice(): string {
        return "";
    }

    public renderButtons(): React.ReactNode {
        return (
            <React.Fragment>
                <Button block type={ButtonType.Dark} label={Localizer.cruiseWizardNext} onClick={() => this.nextAsync()}/>

                <Button block type={ButtonType.Light} label={Localizer.cruiseWizardBack} onClick={() => this.prevAsync()}/>
            </React.Fragment>
        )
    }

    public renderItem(extra: CruiseExtra | null, image: any, label1: string, label2: string): React.ReactNode {
        const selected: boolean = this.isSelected(extra);
        const selectedStyle: any = (selected) && styles.selected;
        const mobileStyle: any = (this.mobile) && styles.mobile;
        return (
            <div className={this.css(styles.item, mobileStyle, selectedStyle)} onClick={() => this.selectAsync(extra)}>
                <div className={styles.image}>
                    <img src={image} alt={label1} />
                </div>
                <div className={styles.label}>
                    <div>
                        <span>{ReactUtility.toMultiLines(label1)}</span>
                    </div>
                    <div>
                        <span>{ReactUtility.toMultiLines(label2)}</span>
                    </div>
                </div>
            </div>
        );
    }

    public renderContent(): React.ReactNode {
        return (
            <div className={styles.extra}>

                <div className={this.css(styles.container, this.mobile && styles.mobile)}>

                    {
                        (this.isFishing)
                            ?
                            (
                                <div className={this.css(styles.row, styles.compact)}>

                                    {this.renderItem(CruiseExtra.FishingEquipment, extraFishingEquipment, Localizer.cruiseWizardFishingEquipment, this.buffetPrice)}

                                    {this.renderItem(null, extraNothing, Localizer.cruiseWizardOwnFishingEquipment, this.noThankYouPrice)}

                                </div>
                            )
                            :
                            (
                                <div className={styles.row}>

                                    {this.renderItem(CruiseExtra.Buffet, extraBuffet, Localizer.cruiseWizardBuffet, this.buffetPrice)}

                                    {this.renderItem(CruiseExtra.Snacks, extraSnacks, Localizer.cruiseWizardSnacks, this.snacksPrice)}

                                    {this.renderItem(CruiseExtra.Alcohol, extraAlcohol, Localizer.cruiseWizardAlcohol, this.alcoholPrice)}

                                    {this.renderItem(null, extraNothing, Localizer.cruiseWizardNoThankYou, this.noThankYouPrice)}

                                </div>
                            )
                    }


                </div>

            </div>
        );
    }
}